module.exports = __webpack_public_path__ + "img/124.50545b07.svg";